import { createServerFn } from "@tanstack/react-start"
import z from "zod"
import DodoPayments from 'dodopayments';
import { environment } from "../lib/constants";
import { authMiddleware } from "./auth";
import { redirect } from '@tanstack/react-router'


const getCheckoutUrlZod = z.object({
    userId: z.string(),
    productId: z.string(),
    return_url: z.string().optional()
})

export const getCheckoutUrl = createServerFn({ method: 'POST' })
    .inputValidator(getCheckoutUrlZod)
    .handler(async ({ data }) => {
        const { currentUser } = await authMiddleware()
        if (!currentUser) {
            throw redirect({ to: '/' })
        }
        const { productId, userId } = data

        // Handle return_url with proper fallback
        const return_url = data.return_url || `${process.env.APP_URL || 'http://localhost:3000'}/dashboard`
        const DODO_PAYMENTS_API_KEY = process.env['DODO_PAYMENTS_API_KEY']
        if (!DODO_PAYMENTS_API_KEY) {
            throw new Error('DODO_PAYMENTS_API_KEY is not defined')
        }
        console.log('f');
        const client = new DodoPayments({
            bearerToken: DODO_PAYMENTS_API_KEY, // This is the default and can be omitted
            environment: environment, // defaults to 'live_mode'
        });
        console.log('g', productId, userId, return_url, DODO_PAYMENTS_API_KEY, environment);

        let checkoutSessionResponse;
        try {
            checkoutSessionResponse = await client.checkoutSessions.create({
                product_cart: [{ product_id: productId, quantity: 1 }],
                metadata: { userId },
                return_url,
                customer: { email: currentUser.email, name: currentUser.name }

            });

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            console.error('DodoPayments API error:', err);
            throw new Error(`Payment API error: ${err?.message || 'Unknown error'}`);
        }
        if (!checkoutSessionResponse.checkout_url) {

            throw new Error('Checkout URL not found')
        }
        return ({ href: checkoutSessionResponse.checkout_url })
    })
